import { render, staticRenderFns } from "./TotalControl.vue?vue&type=template&id=fdd24f42&scoped=true"
import script from "./TotalControl.vue?vue&type=script&lang=js"
export * from "./TotalControl.vue?vue&type=script&lang=js"
import style0 from "./TotalControl.vue?vue&type=style&index=0&id=fdd24f42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd24f42",
  null
  
)

export default component.exports